var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-bs-theme":"dark"}},[_c('Flash'),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }